export default "__VITE_ASSET__DuOcSu$p__"